import React from "react";
import cx from "classnames";
import useSheet from "react-jss";
import PropTypes from "prop-types";

import CloseIcon from "../icons/CloseIcon";

const enhancer = useSheet({
  root: {
    margin: 0,
    display: "flex",
    padding: "16px",
    alignItems: "center",
    borderBottom: "1px solid #ccc"
  },
  button: {
    padding: 0,
    border: "none",
    height: "20px",
    cursor: "pointer",
    background: "none",
    alignItems: "center",
    "& > svg": {
      width: "20px",
      height: "20px"
    }
  },
  title: {
    flex: "1 1 0%",
    display: "flex",
    alignItems: "center",
    "-ms-flex": "1 1 0%"
  },
  msDisplayFlex: {
    display: "-ms-flexbox"
  }
});

DialogTitle.propTypes = {
  classes: PropTypes.object,

  className: PropTypes.string,
  titleClassName: PropTypes.string,

  onClose: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
};

function DialogTitle(props) {
  const { classes } = props;

  return (
    <div className={cx(classes.root, classes.msDisplayFlex, props.className)}>
      <div
        className={cx(
          classes.title,
          classes.msDisplayFlex,
          props.titleClassName
        )}
      >
        {props.title}
      </div>

      {props.onClose && (
        <button onClick={props.onClose} className={classes.button}>
          <CloseIcon />
        </button>
      )}
    </div>
  );
}

export default enhancer(DialogTitle);



// WEBPACK FOOTER //
// ./src/module/components/DialogTitle.js